import styled from 'styled-components';
import { Black2, MangoBrightBlue, White } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';

export const DatePickerInputPillStyle = styled.div`
  .DateInput {
    width: 7rem !important;
  }

  .DateRangePickerInput input::placeholder {
    color: ${White};
  }

  .DateRangePickerInput input {
    font-size: 1rem;
    text-align: center;
    background: ${MangoBrightBlue};
    color: ${White};
    padding: 1px 0;
    cursor: pointer;
    line-height: 2.25rem;
    font-family: ${DemiBold};
    border: none;
    caret-color: ${MangoBrightBlue};
  }

  .DateInput:first-child {
    &:after {
      content: '–';
      position: absolute;
      line-height: 2.25rem;
      right: -0.2rem;
      color: ${White};
      z-index: 1;
      font-family: ${DemiBold};
    }
  }

  .DateRangePickerInput input[id='startDate'] {
    border-right: 0;
    border-radius: 2rem 0 0 2rem;
  }

  .DateRangePickerInput input[id='endDate'] {
    border-right: 0;
    border-radius: 0 2rem 2rem 0;
  }

  .DateRangePickerInput .DateRangePickerInput_arrow {
    display: none;
  }

  .DateRangePickerInput__withBorder {
    background: transparent;
    border: 0;
  }

  .DateRangePickerInput .DateRangePickerInput_arrow_svg,
  .DayPickerNavigation .DayPickerNavigation_button svg {
    fill: ${Black2};
  }

  .DateInput_fang .DateInput_fangStroke {
    stroke: ${White};
    fill: ${White};
  }
`;
